import { render, staticRenderFns } from "./AuditoriaComponent.vue?vue&type=template&id=1b81f9e6&scoped=true"
import script from "./AuditoriaComponent.vue?vue&type=script&lang=js"
export * from "./AuditoriaComponent.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaComponent.vue?vue&type=style&index=0&id=1b81f9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81f9e6",
  null
  
)

export default component.exports